import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
  Result,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const JixiaoList = styled.div`
  .month {
  }
  .month ul {
    list-style: none;
    padding: 10px 20px 10px 20px;
    margin: 0;
  }
  .month li {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    width: 100%;
    padding: 0 10px 0 10px;
    margin-bottom: 10px;
  }
  .month p {
    display: flex;
    justify-content: space-between;
  }
  .center {
    text-align: center;
  }
`;
interface Array1 {
  departmentName: string;
  staffName: string;
  reviewScore: number;
  vsheetId: string;
  uuid: string;
}
export default function PromotionManagement() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const tabs = [{ title: "未考核" }, { title: "已考核" }];
  const [promotionList, setPromotionList] = useState<Array1[]>([]);
  const [promotion1List, setPromotion1List] = useState<Array1[]>([]);
  const [judgeList, setJudgeList] = useState<Array1[]>([]);
  const [judge1List, setJudge1List] = useState<Array1[]>([]);
  const [keyword, setKeyword] = useState<string>();
  const [keyword1, setKeyword1] = useState<string>();
  useEffect(() => {
    let url = window.location.href; //获取请求进来的完整url
    // console.log(url)
    // let tstr = url.substring(url.indexOf('?') + 1).split('&');//先截取url的?后面的参数部分，在根据&分割成参数数组
    let tstr = url.substring(url.indexOf("=") + 1); //获取uuid
    // console.log(tstr);
    instance
      .post(
        `/oa/adjust/getPromotionStaffList?vsheetId=` +
          tstr +
          "&isPromotion=" +
          "true"
      )
      .then((resp) => {
        // console.log(resp);
        // console.log(resp.data.Data.data)
        if (resp.data.Status === "1") {
          setPromotionList(resp.data.Data.data);
          setPromotion1List(resp.data.Data.data);
          let newArr = resp.data.Data.data.filter((item: any, index: any) => {
            return !item.reviewScore;
          });
          let newArr1 = resp.data.Data.data.filter((item: any, index: any) => {
            return item.reviewScore !== "";
          });
          setJudgeList(newArr);
          setJudge1List(newArr1);
        }
      });
  }, []);
  //未考核搜索
  const searchBarChange = useCallback((keyword) => {
    let url = window.location.href;
    let tstr = url.substring(url.indexOf("=") + 1);
    instance
      .post(
        `/oa/adjust/getPromotionStaffList?vsheetId=` +
          tstr +
          "&isPromotion=" +
          "true" +
          "&mobileParam=" +
          keyword
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setPromotionList(resp.data.Data.data);
        }
      });
  }, []);
  const noSearch = useCallback(() => {
    let url = window.location.href;
    let tstr = url.substring(url.indexOf("=") + 1);
    instance
      .post(
        `/oa/adjust/getPromotionStaffList?vsheetId=` +
          tstr +
          "&isPromotion=" +
          "true"
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setPromotionList(resp.data.Data.data);
        }
      });
  }, []);
  //已考核搜索
  const searchBarChange1 = useCallback((keyword1) => {
    let url = window.location.href;
    let tstr = url.substring(url.indexOf("=") + 1);
    instance
      .post(
        `/oa/adjust/getPromotionStaffList?vsheetId=` +
          tstr +
          "&isPromotion=" +
          "true" +
          "&mobileParam=" +
          keyword1
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setPromotion1List(resp.data.Data.data);
        }
      });
  }, []);
  const noSearch1 = useCallback(() => {
    let url = window.location.href;
    let tstr = url.substring(url.indexOf("=") + 1);
    instance
      .post(
        `/oa/adjust/getPromotionStaffList?vsheetId=` +
          tstr +
          "&isPromotion=" +
          "true"
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setPromotion1List(resp.data.Data.data);
        }
      });
  }, []);
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  // history.push(`/hr/rankadjustment`);
                  history.go(-1);
                }}
              />
            }
          >
            晋级管理
          </NavBar>
          <WhiteSpace />
          <Tabs tabs={tabs} initialPage={"t2"}>
            {/* 未考核 */}
            <div className="month">
              <SearchBar
                value={keyword}
                onChange={(value) => setKeyword(value)}
                placeholder="请输入搜索年月"
                className="margin"
                onSubmit={() => {
                  searchBarChange(keyword);
                }}
                onCancel={() => {
                  noSearch();
                }}
              />
              <ul>
                {promotionList.map((item) =>
                  !item.reviewScore ? (
                    <li
                      onClick={() => {
                        window.location.href =
                          "/hr/rankadjustment/promotionmanagement/details?vsheetId=" +
                          item.vsheetId +
                          "&" +
                          encodeURI(item.uuid);
                      }}
                    >
                      <p>
                        <span>{item.departmentName}</span>
                        <span>{item.staffName}</span>
                      </p>
                    </li>
                  ) : (
                    ""
                  )
                )}
              </ul>
              {(judgeList.length === 0 && (
                <div style={{ textAlign: "center" }}>
                  <span>暂无数据</span>
                </div>
              )) ||
                (promotionList.length === 0 && (
                  <div style={{ textAlign: "center" }}>
                    <span>暂无数据</span>
                  </div>
                ))}
            </div>
            {/* 已考核 */}
            <div className="month">
              <SearchBar
                value={keyword1}
                onChange={(value) => setKeyword1(value)}
                placeholder="请输入搜索年月"
                className="margin"
                onSubmit={() => {
                  searchBarChange1(keyword1);
                }}
                onCancel={() => {
                  noSearch1();
                }}
              />
              <ul>
                {promotion1List.map((item) =>
                  item.reviewScore ? (
                    <li
                      onClick={() => {
                        window.location.href =
                          "/hr/rankadjustment/promotionmanagement/details?vsheetId=" +
                          item.vsheetId +
                          "&" +
                          encodeURI(item.uuid);
                      }}
                    >
                      <p>
                        <span>{item.departmentName}</span>
                        <span>{item.staffName}</span>
                      </p>
                    </li>
                  ) : (
                    ""
                  )
                )}
              </ul>
              {(judge1List.length === 0 && (
                <div style={{ textAlign: "center" }}>
                  <span>暂无数据</span>
                </div>
              )) ||
                (promotion1List.length === 0 && (
                  <div style={{ textAlign: "center" }}>
                    <span>暂无数据</span>
                  </div>
                ))}
            </div>
          </Tabs>
        </div>
      </JixiaoList>
    </>
  );
}
